/**
 * Statutory Documents Configuration
 *
 * This file contains all statutory document links and metadata.
 * To add new documents, simply add entries to the respective arrays below.
 */

export const STATUTORY_DOCUMENTS = {
  // Annual Return Forms (MGT-7)
  annualReturns: [
    {
      id: 'mgt7-2024-25',
      fileName: 'MGT-7_FY_2024-25.pdf',
      displayName: 'MGT-7 FY 2024-25.pdf',
      year: '2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/MGT-7/MGT-7_FY_2024-25.pdf',
    },
    {
      id: 'mgt7-2023-24',
      fileName: 'MGT-7_FY_2023-24.pdf',
      displayName: 'MGT-7 FY 2023-24.pdf',
      year: '2023-24',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/MGT-7/MGT-7_FY_2023-24.pdf',
    },
    {
      id: 'mgt7-2022-23',
      fileName: 'MGT-7_FY_2022-23.pdf',
      displayName: 'MGT-7 FY 2022-23.pdf',
      year: '2022-23',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/MGT-7/MGT-7_FY_2022-23.pdf',
    },
    {
      id: 'mgt7a-2021-22',
      fileName: 'MGT-7A_FY_2021-22.pdf',
      displayName: 'MGT-7A FY 2021-22.pdf',
      year: '2021-22',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/MGT-7/MGT-7A_FY_2021-22.pdf',
    },
  ],

  // Notice of General Meetings
  generalMeetings: [
    {
      id: 'agm-2025-26-1',
      fileName: '1-BTPl_AGM_24-09-2025.pdf',
      displayName: 'Notice of AGM 24.09.2025.pdf',
      fiscalYear: 'FY 2025-26',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2025-26/1-BTPl_AGM_24-09-2025.pdf',
    },
    {
      id: 'eogm-2024-25-1',
      fileName: '1-BTPL_EOGM_17-06-24.pdf',
      displayName: 'Notice of EOGM 17.06.2024.pdf',
      fiscalYear: 'FY 2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2024-25/1-BTPL_EOGM_17-06-24.pdf',
    },
    {
      id: 'eogm-2024-25-2',
      fileName: '2-BTPl_EOGM_15-07-24.pdf',
      displayName: 'Notice of EOGM 15.07.2024.pdf',
      fiscalYear: 'FY 2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2024-25/2-BTPl_EOGM_15-07-24.pdf',
    },
    {
      id: 'agm-2024-25-3',
      fileName: '3-BTPL_AGM_Notice_28-09-24.pdf',
      displayName: 'Notice of AGM 28.09.2024.pdf',
      fiscalYear: 'FY 2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2024-25/3-BTPL_AGM_Notice_28-09-24.pdf',
    },
    {
      id: 'eogm-2024-25-4',
      fileName: '4-BTPL_EOGM_25-10-24.pdf',
      displayName: 'Notice of EOGM 25.10.2024.pdf',
      fiscalYear: 'FY 2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2024-25/4-BTPL_EOGM_25-10-24.pdf',
    },
    {
      id: 'eogm-2024-25-5',
      fileName: '5-BTPL_EOGM_21-11-24.pdf',
      displayName: 'Notice of EOGM 21.11.2024.pdf',
      fiscalYear: 'FY 2024-25',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2024-25/5-BTPL_EOGM_21-11-24.pdf',
    },
    {
      id: 'agm-2023-24-1',
      fileName: 'Notice_of_AGM.pdf',
      displayName: 'Notice of AGM.pdf',
      fiscalYear: 'FY 2023-24',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2023-24/Notice_of_AGM.pdf',
    },
    {
      id: 'egm-2022-23-1',
      fileName: 'Notice_of_EGM_01-04-2022.pdf',
      displayName: 'Notice of EGM 01.04.2022.pdf',
      fiscalYear: 'FY 2022-23',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2022-23/Notice_of_EGM_01-04-2022.pdf',
    },
    {
      id: 'egm-2022-23-2',
      fileName: 'Notice_of_EGM_06-01-2023.pdf',
      displayName: 'Notice of EGM 06.01.2023.pdf',
      fiscalYear: 'FY 2022-23',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2022-23/Notice_of_EGM_06-01-2023.pdf',
    },
    {
      id: 'agm-2022-23-3',
      fileName: 'Notice_of_AGM_10-10-2022.pdf',
      displayName: 'Notice of AGM 10.10.2022.pdf',
      fiscalYear: 'FY 2022-23',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2022-23/Notice_of_AGM_10-10-2022.pdf',
    },
    {
      id: 'egm-2021-22-1',
      fileName: 'Notice_of_EGM_16-02-2022.pdf',
      displayName: 'Notice of EGM 16.02.2022.pdf',
      fiscalYear: 'FY 2021-22',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2021-22/Notice_of_EGM_16-02-2022.pdf',
    },
    {
      id: 'egm-2021-22-2',
      fileName: 'Notice_of_EGM_05-03-2022.pdf',
      displayName: 'Notice of EGM 05.03.2022.pdf',
      fiscalYear: 'FY 2021-22',
      s3Url: 'https://elchemy-website.s3.ap-south-1.amazonaws.com/statutory-guidelines/General_Meeting_Notice/FY_2021-22/Notice_of_EGM_05-03-2022.pdf',
    },
  ],
};

/**
 * Company Information
 */
export const COMPANY_INFO = {
  name: 'BizinBiz Technologies Private Limited',
  cin: 'U24290DL2021PTC382855',
  registeredOffice: {
    address: '3/8, Second Floor, Asaf Ali Road, Above Dabur India Ltd, New Delhi, Delhi, India - 110002',
  },
  contact: {
    telephone: '+91 98670 99519',
    email: 'info@elchemy.com',
    contactPerson: 'Hardik Seth',
  },
};

/**
 * Page Metadata
 */
export const PAGE_METADATA = {
  lastUpdated: 'JANUARY 2026',
  complianceNote: 'This page is maintained in compliance with the provisions of the Companies Act, 2013. For any queries or grievances, please contact the designated person mentioned above.',
};

/**
 * Helper function to group general meetings by fiscal year
 */
export const getGeneralMeetingsByYear = () => {
  const groupedByYear = {};

  STATUTORY_DOCUMENTS.generalMeetings.forEach((meeting) => {
    if (!groupedByYear[meeting.fiscalYear]) {
      groupedByYear[meeting.fiscalYear] = [];
    }
    groupedByYear[meeting.fiscalYear].push(meeting);
  });

  return groupedByYear;
};

/**
 * Helper function to get fiscal years with counts
 */
export const getFiscalYearsWithCounts = () => {
  const yearCounts = {};

  STATUTORY_DOCUMENTS.generalMeetings.forEach((meeting) => {
    if (!yearCounts[meeting.fiscalYear]) {
      yearCounts[meeting.fiscalYear] = 0;
    }
    yearCounts[meeting.fiscalYear]++;
  });

  return Object.keys(yearCounts)
    .sort()
    .reverse()
    .map((year) => ({
      year,
      count: yearCounts[year],
    }));
};
